import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  AlertTitle,
  Alert,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ManualConfigurationModalBodyOne from "./ManualConfigurationModalBodyOne";
import ManualConfigurationModalBodyTwo from "./ManualConfigurationModalBodyTwo";

interface Props {
  openAddManualConfigurationModal: boolean;
  handleClose: () => void;
  familiesTitle: string;
  type: string;
}

const FilterByDestinationTable = [
  { label: "Table 01" },
  { label: "Table 02" },
  { label: "Table 03" },
  { label: "Table 04" },
  { label: "Table 05" },
];

const AddManualConfigurationModal = ({
  openAddManualConfigurationModal,
  familiesTitle,
  type,
  handleClose,
}: Props) => {
  return (
    <>
      <Dialog
        open={openAddManualConfigurationModal}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper>
          <Box
            sx={{
              padding: "16px 24px 20px 24px",
              borderBottom: "1px solid #0000001F",
            }}
          >
            <Grid container>
              <Grid size={{ xs: 12, md: 8 }}>
                <DialogTitle
                  sx={{
                    padding: "0px 0px 5px 0px",
                    textTransform: "capitalize",
                  }}
                >
                  Add {familiesTitle}{" "}
                  {type.endsWith("s") ? type.slice(0, -1) : type}
                </DialogTitle>
                <Typography variant="body2" color="#00000061">
                  Awin Sport UK ● <span>IncomeAccess</span> ● Only IncomeAccess
                  maps are listed
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Autocomplete
                  sx={{ width: "100%" }}
                  options={FilterByDestinationTable}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Filter by destination table"
                      label="Filter by destination table"
                      color="secondary"
                    />
                  )}
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              padding: "0px 24px 0px 24px",
            }}
          >
            <Grid container spacing={1}>
              <Grid
                size={{
                  xs: 12,
                  md: familiesTitle === "Fetcher" ? 12 : 6,
                }}
              >
                <ManualConfigurationModalBodyOne />
              </Grid>

              {familiesTitle !== "Fetcher" && (
                <Grid size={{ xs: 12, md: 6 }}>
                  <ManualConfigurationModalBodyTwo familiesTitle={familiesTitle} />
                </Grid>
              )}
            </Grid>
          </Box>

          <Box
            sx={{
              padding: "16px 24px 20px 24px",
              borderTop: "1px solid #0000001F",
            }}
          >
            {/* Validation */}
            <Alert
              icon={<InfoOutlinedIcon />}
              severity="info"
              sx={{
                mb: 2,
                border: "1px solid #0288D180",
                borderRadius: "5px",
                backgroundColor: "#f4faff",
                color: "#0288D10A",
                alignItems: "flex-start",
                p: 1,

                "& .MuiAlert-icon": {
                  color: "#0066a6",
                  fontSize: "20px",
                  p: 0,
                },

                "& .MuiAlert-message": {
                  width: "100%",
                  p: 0,
                },
              }}
            >
              <AlertTitle
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  color: "#01579B",
                  mb: 0,
                }}
              >
                VALIDATION
              </AlertTitle>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#01579B",
                }}
              >
                Connecting a brand verifies every required column exists on the
                brand's raw_data table. Missing columns block the connection.
              </Typography>
            </Alert>

            <Stack flexDirection={"row"} justifyContent={"end"} gap={1}>
              <Button variant="text" color="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                variant="contained"
                //disabled
                color="secondary"
                endIcon={<SaveOutlinedIcon />}
              >
                save
              </Button>
              <Button
                variant="contained"
                //disabled
                color="secondary"
                endIcon={<SwapHorizIcon />}
              >
                Replace
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Dialog>
    </>
  );
};

export default AddManualConfigurationModal;
